import Div from '@jumbo/shared/Div';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { dateFun } from 'app/utils/constants/functions';
import axios from 'axios';
import { useFormik } from 'formik';
import React, { useState } from 'react'
import Swal from 'sweetalert2';
import dayjs from "dayjs";
import { getAllFinishedGoods, getAllRawMaterial } from 'app/redux/actions/inventoryAction';
import { useDispatch } from 'react-redux';

const EditInvoice = ({ open, setOpen }) => {
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState("")
    const [invoiceValue, setInvoiceValue] = useState({
        invoiceNo: '',
        invoiceType: 'Raw Material',
    })

    const handleSubmit = async function (values) {
        try {
            const config = {
                withCredentials: true,
                headers: {
                    withCredentials: true,
                },
            };

            const res = await axios.post(`${process.env.REACT_APP_URL}/api/inventory/list/edit-invoice/${invoiceValue?.invoiceNo}`, {
                invoiceNo: values?.invoiceNo,
                invoiceDate: values?.invoiceDate,
                invoiceType: invoiceValue?.invoiceType
            }, config);

            if (res?.status === 200) {
                Swal.fire({ icon: "success", title: `Invoice Edit Successfully` });
                setErrorMessage("")
                setOpen(false);
                if(invoiceValue?.invoiceType === "Raw Material"){
                    dispatch(getAllRawMaterial("", "",1));
                }else{
                    dispatch(getAllFinishedGoods("", "", 1));
                }
            }
        } catch (error) {
            // Swal.fire({ icon: "error", title: `${error?.response?.data?.message}` });
            setErrorMessage(error?.response?.data?.message)
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            invoiceNo: '',
            invoiceDate: '',
            isSuccess:false
        },
        onSubmit: handleSubmit
    })
    const onClose = function () {
        setOpen(false)
    }
    const handleInvoiceFetch = async function (event) {
        try {
            if (invoiceValue?.invoiceNo) {
                const config = {
                    withCredentials: true,
                    headers: {
                        withCredentials: true,
                    },
                };
                const res = await axios.get(`${process.env.REACT_APP_URL}/api/inventory/list/check-invoice?invoiceNo=${invoiceValue?.invoiceNo}&invoiceType=${invoiceValue?.invoiceType}`, config);

                if (res?.status === 200) {
                    formik.setValues({
                        invoiceNo: res?.data?.result?.invoiceNo,
                        invoiceDate: dateFun(res?.data?.result?.invoiceDate),
                        isSuccess:true
                    })
                    setErrorMessage("")
                }
            }

        } catch (error) {
            // Swal.fire({ icon: "error", title: `${error?.response?.data?.message}` });
            // setInvoiceValue({
            //     invoiceNo: '',
            //     invoiceType: 'Raw Material',
            // })
            setErrorMessage(error?.response?.data?.message)
            formik?.resetForm()
        }
    }

    return (
        <>
            <Box>
                {open && <Dialog open={open} onClose={onClose} fullWidth>
                    <DialogTitle sx={{ fontWeight: "700" }}>
                        Edit Invoice
                    </DialogTitle>
                    <DialogContent>
                        <Box sx={{ mt: 2, display: "flex", gap: 3, width: "100%" }}>
                            <Box sx={{ width: "50%" }}>
                                <FormControl size="small" fullWidth>
                                    <InputLabel id="invoice-type-label">Invoice Type</InputLabel>
                                    <Select
                                        labelId="invoice-type-label"
                                        value={invoiceValue?.invoiceType}
                                        label="Invoice Type"
                                        onChange={(e) => {
                                            setInvoiceValue((prev) => ({ ...prev, invoiceType: e.target.value, invoiceNo: "" }))
                                            setErrorMessage("")
                                            formik?.resetForm()
                                        }}
                                    >
                                        <MenuItem value="Raw Material">Raw Material</MenuItem>
                                        <MenuItem value="Finished Goods">Finished Goods</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{ width: "50%" }}>
                                <TextField
                                    size='small'
                                    label="Enter Invoice No"
                                    name="invoiceNo"
                                    value={invoiceValue?.invoiceNo}
                                    sx={{ width: "100%" }}
                                    onBlur={handleInvoiceFetch}
                                    onChange={(e) => setInvoiceValue((prev) => ({ ...prev, invoiceNo: e.target.value }))}
                                />
                            </Box>
                        </Box>
                        {formik?.values?.isSuccess && <Box sx={{ mt: 4, display: "flex", gap: 3 }}>
                            <Box sx={{ width: "50%" }}>
                                <TextField
                                    size='small'
                                    label="New Invoice No"
                                    name="invoiceNo"
                                    sx={{ width: "100%" }}
                                    value={formik?.values?.invoiceNo}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={Boolean(formik?.errors?.invoiceNo && formik?.touched?.invoiceDate)}
                                    helperText={formik?.errors?.invoiceNo && formik?.touched?.invoiceDate ? formik?.errors?.invoiceNo : null}
                                />
                            </Box>
                            <Box sx={{ width: "50%" }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Div sx={{ width: "100%" }}>
                                        <DatePicker
                                            format="DD/MM/YY"
                                            label="New Invoice Date"
                                            value={formik?.values?.invoiceDate ? dayjs(formik.values.invoiceDate) : dayjs()} // Ensure value is a Dayjs object
                                            onChange={(date) => {
                                                formik?.setFieldValue("invoiceDate", dateFun(dayjs(date || dayjs()))); // Ensure date is converted to Dayjs
                                            }}
                                            sx={{
                                                width: "100%",
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#8595A6 !important"
                                                },
                                                "& .MuiInputBase-input": {
                                                    padding: 1,
                                                },
                                                "& .MuiInputLabel-root": {
                                                    color: "#8595A6"
                                                },
                                            }}
                                        />
                                    </Div>
                                </LocalizationProvider>
                            </Box>
                        </Box>}

                        {errorMessage && <Typography sx={{ textAlign: "center", mt: 2 }} color="error">{errorMessage}</Typography>}

                    </DialogContent>
                    <DialogActions>
                        <Div
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 3,
                                mb: 2
                            }}
                        >
                            <Button
                                variant="outlined"
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            {formik?.values?.isSuccess && <Button variant='contained' disabled={formik?.isSubmitting} onClick={formik.handleSubmit}>Submit</Button>}
                        </Div>
                    </DialogActions>
                </Dialog>}
            </Box>
        </>
    )
}

export default EditInvoice